/* Gomilovers · comportamiento del tema. Sin dependencias. */
(function () {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const G = window.gomilovers || {};
  const rutas = G.rutas || {};
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // En iPhone, :active (el color claro de los botones al tocarlos) solo se aplica si la página escucha toques
  document.addEventListener('touchstart', () => {}, { passive: true });

  /* ---------- Volver atrás: la página regresa al punto donde estaba ---------- */
  // Se guarda la posición al salir de cada página y se repone al volver con el botón atrás,
  // sin el desplazamiento suave (que hacía que la página llegara a otro lado o al pie).
  const claveScroll = `gomi-scroll:${location.pathname}${location.search}`;
  window.addEventListener('pagehide', () => { try { sessionStorage.setItem(claveScroll, String(window.scrollY)); } catch (e) { /* sin almacenamiento */ } });
  const navegacion = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  if (navegacion && navegacion.type === 'back_forward') {
    let y = null;
    try { y = sessionStorage.getItem(claveScroll); } catch (e) { /* sin almacenamiento */ }
    if (y !== null) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      const destino = Number(y);
      let tocado = false;
      const reponer = () => { if (!tocado) window.scrollTo(0, destino); };
      // Si la persona empieza a desplazarse, no se la vuelve a mover.
      ['touchstart', 'wheel', 'keydown'].forEach((ev) => window.addEventListener(ev, () => { tocado = true; }, { once: true, passive: true }));
      reponer();
      requestAnimationFrame(reponer);
      window.addEventListener('load', reponer, { once: true });
      // Las fotos que terminan de cargar alargan la página: se reintenta hasta 1.5 s si todavía no se llegó.
      const t0 = Date.now();
      const reintentar = () => { if (tocado || Math.abs(window.scrollY - destino) < 4 || Date.now() - t0 > 1500) return; reponer(); setTimeout(reintentar, 120); };
      setTimeout(reintentar, 120);
    }
  }

  /* ---------- Avisos ---------- */
  function avisar(texto, tono) {
    let caja = q('#avisos');
    if (!caja) { caja = document.createElement('div'); caja.id = 'avisos'; caja.className = 'avisos'; caja.setAttribute('aria-live', 'polite'); document.body.appendChild(caja); }
    const a = document.createElement('div');
    a.className = 'aviso' + (tono === 'error' ? ' aviso--error' : '');
    a.textContent = texto;
    caja.appendChild(a);
    setTimeout(() => a.remove(), 3600);
  }
  G.avisar = avisar;

  /* ---------- Capas (menú móvil, carrito) ---------- */
  let ultimoFoco = null;
  function abrirCapa(capa) {
    if (!capa) return;
    ultimoFoco = document.activeElement;
    capa.hidden = false;
    document.documentElement.classList.add('bloqueado');
    const enfocable = q('[data-foco-inicial]', capa) || q('button, a, input', capa);
    if (enfocable) setTimeout(() => enfocable.focus(), 30);
  }
  function cerrarCapa(capa) {
    if (!capa || capa.hidden || capa.classList.contains('cerrando')) return;
    if (!reducido) {
      capa.classList.add('cerrando');
      setTimeout(() => { capa.classList.remove('cerrando'); capa.hidden = true; if (!qa('[data-capa]').some((c) => !c.hidden)) document.documentElement.classList.remove('bloqueado'); }, 280);
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
      return;
    }
    capa.hidden = true;
    if (!qa('[data-capa]').some((c) => !c.hidden)) document.documentElement.classList.remove('bloqueado');
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }
  document.addEventListener('click', (e) => {
    const abre = e.target.closest('[data-abrir]');
    if (abre) {
      const capa = document.getElementById(abre.getAttribute('data-abrir'));
      if (capa) { e.preventDefault(); abrirCapa(capa); abre.setAttribute('aria-expanded', 'true'); }
      return;
    }
    const cierra = e.target.closest('[data-cerrar]');
    if (cierra) { const capa = cierra.closest('[data-capa]'); cerrarCapa(capa); qa(`[data-abrir="${capa && capa.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    qa('[data-capa]').forEach((c) => cerrarCapa(c));
    const b = q('[data-buscador]'); if (b && !b.hidden) alternarBuscador(false);
  });
  // Mantener el foco dentro de la capa abierta
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const capa = qa('[data-capa]').find((c) => !c.hidden);
    if (!capa) return;
    const f = qa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', capa).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const primero = f[0]; const ultimo = f[f.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });

  /* ---------- Buscador con predictiva ---------- */
  function alternarBuscador(abrir) {
    const b = q('[data-buscador]'); const boton = q('[data-boton-buscar]');
    if (!b) return false;
    b.hidden = !abrir;
    if (boton) boton.setAttribute('aria-expanded', String(abrir));
    if (abrir) { const i = q('input[type="search"]', b); if (i) i.focus(); }
    return true;
  }
  document.addEventListener('click', (e) => {
    const boton = e.target.closest('[data-boton-buscar]');
    if (boton) { const b = q('[data-buscador]'); if (b) { e.preventDefault(); alternarBuscador(b.hidden); } }
  });
  let temporizador;
  qa('[data-predictiva-input]').forEach((input) => {
    const caja = q(`#${input.getAttribute('aria-controls')}`);
    if (!caja) return;
    input.addEventListener('input', () => {
      clearTimeout(temporizador);
      const termino = input.value.trim();
      if (termino.length < 2) { caja.innerHTML = ''; caja.hidden = true; return; }
      temporizador = setTimeout(async () => {
        try {
          const url = `${rutas.predictiva}?q=${encodeURIComponent(termino)}&resources[type]=product,article&resources[limit]=4&section_id=predictiva`;
          const res = await fetch(url);
          if (!res.ok) return;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nuevo = q('[data-predictiva-resultados]', doc);
          caja.innerHTML = nuevo ? nuevo.innerHTML : '';
          caja.hidden = !caja.innerHTML.trim();
        } catch (err) { /* sin conexión: la búsqueda normal sigue funcionando */ }
      }, 220);
    });
  });
  qa('[data-limpiar-busqueda]').forEach((b) => b.addEventListener('click', () => { const i = b.closest('form').querySelector('input[type="search"]'); i.value = ''; i.focus(); i.dispatchEvent(new Event('input')); }));

  /* ---------- Carrito ---------- */
  const carrito = {
    capa() { return q('#carrito'); },
    async pedir(url, cuerpo) {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || G.t.error_carrito);
      return data;
    },
    pintar(html) {
      const capa = this.capa(); if (!capa || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nuevo = q('[data-carrito-contenido]', doc); const actual = q('[data-carrito-contenido]', capa);
      if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
      // En /cart la página tiene su propio marcado (enlaces en vez de cerrar panel): se recarga.
      if (q('[data-carrito-pagina]')) window.location.reload();
    },
    contador(n) {
      qa('[data-carrito-contador]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
      qa('[data-carrito-enlace]').forEach((a) => a.setAttribute('aria-label', `${G.t.carrito} (${n})`));
    },
    async refrescar() {
      const res = await fetch(`${rutas.root}?sections=carrito`);
      const data = await res.json();
      this.pintar(data.carrito);
      const c = await (await fetch(`${rutas.cart}.js`)).json();
      this.contador(c.item_count);
    },
    async agregar(items) {
      const data = await this.pedir(`${rutas.cart_add}.js`, { items, sections: 'carrito' });
      this.pintar(data.sections && data.sections.carrito);
      const c = await (await fetch(`${rutas.cart}.js`)).json();
      this.contador(c.item_count);
      return data;
    },
    async cambiar(key, cantidad) {
      const capa = this.capa(); if (capa) capa.classList.add('cargando');
      const pagina = q('[data-carrito-pagina]'); if (pagina) pagina.classList.add('cargando');
      try {
        const data = await this.pedir(`${rutas.cart_change}.js`, { id: key, quantity: cantidad, sections: 'carrito' });
        this.pintar(data.sections && data.sections.carrito);
        this.contador(data.item_count);
      } catch (err) { avisar(err.message, 'error'); }
      finally { if (capa) capa.classList.remove('cargando'); if (pagina) pagina.classList.remove('cargando'); }
    },
    async cupon(codigo, quitar) {
      const c = await (await fetch(`${rutas.cart}.js`)).json();
      const actuales = (c.discount_codes || []).map((d) => d.code);
      const lista = quitar ? actuales.filter((x) => x.toLowerCase() !== codigo.toLowerCase()) : [...new Set([...actuales, codigo])];
      const data = await this.pedir(`${rutas.cart}/update.js`, { discount: lista.join(','), sections: 'carrito' });
      if (!quitar) {
        const ok = (data.discount_codes || []).find((d) => d.code.toLowerCase() === codigo.toLowerCase());
        if (!ok || !ok.applicable) {
          await this.pedir(`${rutas.cart}/update.js`, { discount: actuales.join(',') });
          await this.refrescar();
          return false;
        }
      }
      this.pintar(data.sections && data.sections.carrito);
      return true;
    },
    abrir() { const capa = this.capa(); if (capa && !q('[data-carrito-pagina]')) abrirCapa(capa); }
  };
  G.carrito = carrito;

  // Formularios de compra: [data-form-compra] (ficha, destacado, packs, tarjetas)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-form-compra]');
    if (!form) return;
    e.preventDefault();
    const boton = e.submitter || q('[type="submit"]', form);
    const fd = new FormData(form);
    const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
    qa('[data-extra]:checked', form).forEach((x) => items.push({ id: Number(x.value), quantity: 1 }));
    if (!items[0].id) { avisar(G.t.elige_pack, 'error'); return; }
    if (boton) boton.classList.add('cargando');
    try {
      await carrito.agregar(items);
      if (form.hasAttribute('data-directo') || (boton && boton.hasAttribute('data-directo'))) { window.location.href = rutas.checkout; return; }
      if (!form.hasAttribute('data-sin-abrir')) setTimeout(() => carrito.abrir(), reducido ? 0 : 420);
    } catch (err) { avisar(err.message, 'error'); }
    finally { if (boton) boton.classList.remove('cargando'); }
  });

  // Cantidades, quitar, cupón (delegado: el contenido se repinta)
  document.addEventListener('click', async (e) => {
    const paso = e.target.closest('[data-paso]');
    if (paso) {
      const linea = paso.closest('[data-linea]'); const input = q('input', linea);
      const nueva = Math.max(0, Number(input.value) + Number(paso.getAttribute('data-paso')));
      carrito.cambiar(linea.getAttribute('data-linea'), nueva);
      return;
    }
    const mejorar = e.target.closest('[data-mejorar]');
    if (mejorar) {
      mejorar.disabled = true;
      try {
        await carrito.pedir(`${rutas.cart_change}.js`, { id: mejorar.getAttribute('data-mejorar'), quantity: 0 });
        await carrito.agregar([{ id: Number(mejorar.getAttribute('data-variante')), quantity: Number(mejorar.getAttribute('data-cantidad') || 1) }]);
        avisar('Listo: ahora llevas 2 frascos');
      } catch (err) { avisar(err.message, 'error'); mejorar.disabled = false; }
      return;
    }
    const quitar = e.target.closest('[data-quitar]');
    if (quitar) { carrito.cambiar(quitar.closest('[data-linea]').getAttribute('data-linea'), 0); return; }
    const sacar = e.target.closest('[data-quitar-cupon]');
    if (sacar) { e.preventDefault(); await carrito.cupon(sacar.getAttribute('data-quitar-cupon'), true); return; }
    const cartIcono = e.target.closest('[data-carrito-enlace]');
    if (cartIcono && carrito.capa() && !q('[data-carrito-pagina]')) { e.preventDefault(); carrito.abrir(); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-linea] input');
    if (input) carrito.cambiar(input.closest('[data-linea]').getAttribute('data-linea'), Math.max(0, Number(input.value) || 0));
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-cupon]');
    if (!form) return;
    e.preventDefault();
    const input = q('input', form); const codigo = input.value.trim(); if (!codigo) return;
    const boton = q('button', form); boton.classList.add('cargando');
    try {
      const ok = await carrito.cupon(codigo);
      if (!ok) { const err = q('[data-cupon-error]'); if (err) { err.textContent = G.t.cupon_invalido.replace('__C__', codigo); err.hidden = false; } }
      else avisar(G.t.cupon_ok.replace('__C__', codigo));
    } catch (err) { avisar(err.message, 'error'); }
    finally { const b = q('[data-cupon] button'); if (b) b.classList.remove('cargando'); }
  });

  /* ---------- Selector de pack: precio, URL, barra fija ---------- */
  qa('[data-selector-pack]').forEach((form) => {
    const sincronizar = () => {
      const elegida = q('input[name="id"]:checked', form);
      if (!elegida) return;
      qa('.opcion-pack', form).forEach((o) => o.classList.toggle('elegida', o.contains(elegida)));
      const barra = q('[data-barra-compra]');
      if (barra && form.hasAttribute('data-principal')) {
        const p = q('[data-barra-pack]', barra); const m = q('[data-barra-monto]', barra);
        if (p) p.textContent = elegida.getAttribute('data-rotulo') || '';
        if (m) m.textContent = elegida.getAttribute('data-precio') || '';
      }
      if (form.hasAttribute('data-principal') && window.history.replaceState) {
        const url = new URL(window.location.href); url.searchParams.set('variant', elegida.value);
        window.history.replaceState({}, '', url.toString());
      }
    };
    form.addEventListener('change', sincronizar);
    sincronizar();
  });

  // Barra fija: aparece cuando el botón principal sale de la vista
  const cta = q('[data-cta-principal]'); const barra = q('[data-barra-compra]');
  if (cta && barra && 'IntersectionObserver' in window) {
    const pie = q('.pie');
    let ctaFuera = false; let pieVisible = false;
    const actualizar = () => barra.classList.toggle('visible', ctaFuera && !pieVisible);
    new IntersectionObserver(([en]) => { ctaFuera = !en.isIntersecting && en.boundingClientRect.top < 0; actualizar(); }).observe(cta);
    if (pie) new IntersectionObserver(([en]) => { pieVisible = en.isIntersecting; actualizar(); }).observe(pie);
    q('[data-barra-boton]', barra).addEventListener('click', () => { const f = cta.closest('form'); if (f) f.requestSubmit(); });
  }

  /* ---------- Carruseles con flechas (promociones del home) ---------- */
  qa('[data-carrusel]').forEach((c) => {
    const pista = q('[data-carrusel-pista]', c); const izq = q('[data-carrusel-flecha="-1"]', c); const der = q('[data-carrusel-flecha="1"]', c);
    if (!pista) return;
    const estado = () => {
      if (izq) izq.disabled = pista.scrollLeft <= 2;
      if (der) der.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };
    const paso = () => { const t = pista.firstElementChild; return t ? t.getBoundingClientRect().width + parseFloat(getComputedStyle(pista).columnGap || 0) : pista.clientWidth; };
    [izq, der].forEach((b) => b && b.addEventListener('click', () => pista.scrollBy({ left: Number(b.getAttribute('data-carrusel-flecha')) * paso(), behavior: reducido ? 'auto' : 'smooth' })));
    pista.addEventListener('scroll', estado, { passive: true }); window.addEventListener('resize', estado); estado();
  });

  /* ---------- Galería ---------- */
  qa('[data-galeria]').forEach((g) => {
    const slides = qa('[data-slide]', g); const minis = qa('[data-mini]', g);
    const pista = q('[data-pista]', g);
    const ir = (i) => {
      slides.forEach((s, k) => { s.classList.toggle('activa', k === i); s.setAttribute('aria-hidden', String(k !== i)); });
      minis.forEach((m, k) => m.setAttribute('aria-current', String(k === i)));
      if (minis[i]) minis[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducido ? 'auto' : 'smooth' });
    };
    minis.forEach((m, i) => m.addEventListener('click', () => ir(i)));
    const flechas = qa('[data-flecha]', g);
    const estadoFlechas = () => {
      if (!pista) return;
      const izq = flechas.find((f) => f.getAttribute('data-flecha') === '-1'); const der = flechas.find((f) => f.getAttribute('data-flecha') === '1');
      if (izq) izq.disabled = pista.scrollLeft <= 2;
      if (der) der.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };
    flechas.forEach((f) => f.addEventListener('click', () => { pista.scrollBy({ left: Number(f.getAttribute('data-flecha')) * 104 * 3, behavior: reducido ? 'auto' : 'smooth' }); }));
    if (pista) { pista.addEventListener('scroll', estadoFlechas, { passive: true }); estadoFlechas(); }
    // Al cambiar de pack se muestra la foto de esa variante si tiene una propia
    const form = q('[data-selector-pack][data-principal]');
    if (form) form.addEventListener('change', (e) => {
      const media = e.target.getAttribute && e.target.getAttribute('data-media');
      if (!media) return;
      const i = slides.findIndex((s) => s.getAttribute('data-media-id') === media);
      if (i > -1) ir(i);
    });
    // Deslizar en táctil
    const principal = q('.galeria__principal', g);
    let x0 = null;
    if (principal) {
      principal.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', (e) => {
        if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        const actual = slides.findIndex((s) => s.classList.contains('activa'));
        ir(Math.min(slides.length - 1, Math.max(0, actual + (dx < 0 ? 1 : -1))));
      });
    }
  });

  // Favoritos: se guardan en este navegador
  const FAV = 'gomilovers-favoritos';
  const leerFav = () => { try { return JSON.parse(localStorage.getItem(FAV) || '[]'); } catch (e) { return []; } };
  qa('[data-favorito]').forEach((b) => {
    const id = b.getAttribute('data-favorito');
    b.setAttribute('aria-pressed', String(leerFav().includes(id)));
    b.addEventListener('click', () => {
      let lista = leerFav();
      const esta = lista.includes(id);
      lista = esta ? lista.filter((x) => x !== id) : lista.concat(id);
      try { localStorage.setItem(FAV, JSON.stringify(lista)); } catch (e) { /* sin almacenamiento */ }
      b.setAttribute('aria-pressed', String(!esta));
      avisar(esta ? G.t.fav_quitado : G.t.fav_guardado);
    });
  });

  /* ---------- Hero con diapositivas ---------- */
  qa('[data-hero]').forEach((hero) => {
    const slides = qa('[data-hero-slide]', hero); const puntos = qa('[data-hero-punto]', hero);
    if (slides.length < 2) return;
    let i = 0; let timer = null;
    const segundos = Number(hero.getAttribute('data-segundos') || 6);
    const ir = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('activa', k === i); s.setAttribute('aria-hidden', String(k !== i)); s.toggleAttribute('inert', k !== i); });
      puntos.forEach((p, k) => p.setAttribute('aria-current', String(k === i)));
    };
    hero.style.setProperty('--dur', `${segundos}s`);
    const parar = () => { clearInterval(timer); timer = null; hero.classList.add('pausado'); };
    const seguir = () => { if (reducido || !hero.hasAttribute('data-auto')) return; parar(); hero.classList.remove('pausado'); timer = setInterval(() => ir(i + 1), segundos * 1000); };
    puntos.forEach((p, k) => p.addEventListener('click', () => { ir(k); seguir(); }));
    hero.addEventListener('mouseenter', parar); hero.addEventListener('mouseleave', seguir);
    hero.addEventListener('focusin', parar); hero.addEventListener('focusout', seguir);
    ir(0); seguir();
  });

  /* ---------- Filtros en página (home y preguntas frecuentes) ---------- */
  qa('[data-filtro-grupo]').forEach((grupo) => {
    const destino = document.getElementById(grupo.getAttribute('data-filtro-grupo'));
    if (!destino) return;
    const conteo = q('[data-filtro-conteo]', grupo.closest('section') || document);
    grupo.addEventListener('click', (e) => {
      const b = e.target.closest('[data-filtro]'); if (!b) return;
      const valor = b.getAttribute('data-filtro');
      qa('[data-filtro]', grupo).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      let visibles = 0;
      qa('[data-categoria]', destino).forEach((item) => {
        const ok = valor === 'todo' || item.getAttribute('data-categoria').split(' ').includes(valor);
        item.hidden = !ok; if (ok) visibles += 1;
      });
      if (conteo) conteo.textContent = (conteo.getAttribute('data-plantilla') || '__N__').replace('__N__', visibles);
    });
  });

  /* ---------- Boletín: casilla de términos obligatoria ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form'); if (!form || !form.querySelector('[data-terminos]')) return;
    const casilla = q('input[type="checkbox"][data-terminos]', form);
    if (casilla && !casilla.checked) { e.preventDefault(); avisar(G.t.acepta_terminos, 'error'); casilla.focus(); }
  });

  /* ---------- Movimiento: entradas al hacer scroll y cabecera ---------- */
  const cabecera = q('.cabecera');
  if (cabecera) {
    const sombra = () => cabecera.classList.toggle('con-sombra', window.scrollY > 8);
    window.addEventListener('scroll', sombra, { passive: true }); sombra();
  }
  if (!reducido && 'IntersectionObserver' in window) {
    const selector = '.encabezado, .card, .pack, .sello, .tile, .testimonio, .ingrediente, .articulo-card, .cifra, .destacado__media, .destacado__info, .historia__copy, .historia__media, .calidad__foto, .acordeon > details, .tarjeta-form, .tarjeta-coral, .tipo, .datos-empresa, .libro__form, .tarjeta-cuenta, .panel, .banda__copy, .marketplaces__fila li, .producto-articulo__caja, .prosa > *, .contacto__intro, .coleccion__cabecera, .busqueda__caja';
    // Las tarjetas de una fila que se desliza no se animan una por una: al deslizar entraban de a una y la fila rebotaba.
    // La fila completa aparece como un bloque.
    const filas = '.promos-home__pista, .deslizable';
    // Las tarjetas de producto, pack y artículo quedan fijas: al hacer scroll aparecían subiendo y la grilla "rebotaba".
    const fijas = '.card, .pack, .articulo-card';
    const items = qa(selector).filter((el) => !el.closest('.carrito, .menu-movil, .hero') && !el.closest(filas) && !el.matches(fijas)).concat(qa(filas));
    const visto = new IntersectionObserver((entradas) => {
      entradas.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('visible'); visto.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => {
      const hermanos = Array.from(el.parentElement ? el.parentElement.children : []).filter((h) => h.matches(selector));
      el.style.setProperty('--i', Math.min(hermanos.indexOf(el), 6));
      el.setAttribute('data-revelar', '');
      visto.observe(el);
    });
    // Títulos palabra por palabra
    qa('.encabezado .titulo, .titulo-animado').forEach((t) => {
      if (t.children.length) return;
      const palabras = t.textContent.trim().split(/\s+/);
      t.innerHTML = palabras.map((p, k) => `<span class="palabra" style="--w:${k}">${p}${k < palabras.length - 1 ? ' ' : ''}</span>`).join('');
    });
    // Fotos grandes que se descubren
    qa('.historia__media, .calidad__foto, .destacado__media, .articulo__portada').forEach((el) => el.classList.add('descubre'));
    // Cifras que cuentan desde cero
    const cuenta = new IntersectionObserver((entradas) => {
      entradas.forEach((en) => {
        if (!en.isIntersecting) return; cuenta.unobserve(en.target);
        const el = en.target; const original = el.textContent; const m = original.match(/([\d.,]+)/); if (!m) return;
        const fin = Number(m[1].replace(/[.,]/g, '')); const usaComa = m[1].includes(',');
        const t0 = performance.now(); const dur = 1400;
        const paso = (t) => { const k = Math.min(1, (t - t0) / dur); const v = Math.round(fin * (1 - Math.pow(1 - k, 3)));
          el.textContent = original.replace(m[1], usaComa ? v.toLocaleString('en-US') : String(v)); if (k < 1) requestAnimationFrame(paso); };
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    qa('.cifra__numero').forEach((el) => cuenta.observe(el));
    // La foto del hero se desplaza un poco más lento que la página
    const heroFotos = qa('.hero__fondo');
    if (heroFotos.length && window.matchMedia('(min-width: 990px)').matches) {
      let pendiente = false;
      window.addEventListener('scroll', () => { if (pendiente) return; pendiente = true; requestAnimationFrame(() => { const y = Math.min(window.scrollY, 700); heroFotos.forEach((f) => { f.style.transform = `translateY(${y * 0.18}px)`; }); pendiente = false; }); }, { passive: true });
    }
    document.documentElement.classList.add('anima');
    // Lo que ya está en pantalla al cargar aparece sin esperar el scroll
    requestAnimationFrame(() => items.forEach((el) => { const r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('visible'); }));
  }

  /* ---------- Upsells de pack ---------- */
  const fmt = (c) => `S/ ${(c / 100).toFixed(2)}`;

  // Empujón bajo el selector: si eligió 1 frasco, cuánto más cuesta llevar 2 y cuánto ahorra
  const formPrincipal = q('[data-selector-pack][data-principal]');
  if (formPrincipal) {
    const empujon = q('[data-empujon]', formPrincipal);
    const radios = qa('input[name="id"]', formPrincipal);
    const precio = (r) => Number((r.getAttribute('data-precio') || '').replace(/[^\d.]/g, '')) * 100;
    const actualizarEmpujon = () => {
      if (!empujon || radios.length < 2) return;
      const elegida = radios.find((r) => r.checked); const i = radios.indexOf(elegida); const siguiente = radios[i + 1];
      if (!elegida || i !== 0 || !siguiente || siguiente.disabled) { empujon.hidden = true; return; }
      const dif = precio(siguiente) - precio(elegida);
      const ahorro = precio(elegida) * 2 - precio(siguiente);
      empujon.innerHTML = `Por solo <strong>${fmt(dif)} más</strong> llevas 2 frascos y ahorras ${fmt(ahorro)}. <button type="button" data-subir>Cambiar a 2 frascos</button>`;
      empujon.hidden = false;
      q('[data-subir]', empujon).addEventListener('click', () => { siguiente.checked = true; siguiente.dispatchEvent(new Event('change', { bubbles: true })); });
    };
    formPrincipal.addEventListener('change', actualizarEmpujon); actualizarEmpujon();
  }

  /* ---------- Fotos: fundido al cargar ---------- */
  // La segunda foto de la tarjeta (la que aparece al pasar el mouse) queda fuera: el fundido la dejaba visible fija.
  qa('img[loading="lazy"]:not(.card__foto-2)').forEach((img) => {
    if ((img.complete && img.naturalWidth) || img.style.backgroundImage) return;
    img.classList.add('por-cargar');
    const listo = () => { img.classList.remove('por-cargar'); img.classList.add('cargada'); };
    img.addEventListener('load', listo, { once: true }); img.addEventListener('error', listo, { once: true });
  });

  /* ---------- Orden en búsqueda ---------- */
  qa('[data-orden]').forEach((s) => s.addEventListener('change', () => { const url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); window.location.href = url.toString(); }));
})();
